function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "EAS_primary_logo-01",
  fill: "#24394A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M200.492,0 L174.86,0 C168.216,0 161.852,2.461 156.917,6.951 L56.315,106.404 C53.698,108.782 50.308,110.092 46.77,110.092 L26.643,110.092 C18.818,110.092 12.452,103.726 12.452,95.903 L12.452,26.643 C12.452,18.818 18.818,12.452 26.643,12.452 L91.35,12.452 C95.14,12.452 98.703,13.928 101.383,16.608 L114.479,29.705 L123.283,20.898 L110.188,7.804 C105.155,2.771 98.466,0 91.35,0 L26.643,0 C11.952,0 0,11.952 0,26.643 L0,95.903 C0,110.594 11.952,122.546 26.643,122.546 L46.77,122.546 C53.412,122.546 59.776,120.086 64.713,115.597 L165.317,16.142 C167.936,13.762 171.325,12.452 174.86,12.452 L200.492,12.452 C203.312,12.452 209.178,12.452 209.178,26.643 L209.178,95.903 C209.178,103.727 202.812,110.092 194.988,110.092 L130.282,110.092 C126.489,110.092 122.926,108.617 120.247,105.938 L107.074,92.764 L98.271,101.568 L111.444,114.742 C116.477,119.775 123.167,122.546 130.282,122.546 L194.988,122.546 C209.678,122.546 221.629,110.594 221.629,95.903 L221.629,26.643 C221.629,2.596 206.848,0 200.492,0 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "25.035 24.834 25.035 97.712 46.47 97.712 103.317 40.866 87.284 24.834"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "196.596 97.712 196.596 24.834 175.159 24.834 118.313 81.68 134.345 97.712"
}))));

var SvgMark = function SvgMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "222px",
    height: "123px",
    viewBox: "0 0 222 123",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mark.2a806ce2.svg";
export { ForwardRef as ReactComponent };